import { axiosInstance } from '../Api';

export default class Pages {
  async getPriceTable() {
    try {
      const r = await axiosInstance.get('/Price/GetPricingTable');
      if (r.data.Error) {
        throw new Error('false');
      }
      return r.data.Result;
    } catch (error) {
      return [];
    }
  }
}
